import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SurveyService } from '@app/services';

@Component({
  selector: 'app-survey-add-edit',
  templateUrl: './survey-add-edit.component.html',
  styleUrls: ['./survey-add-edit.component.scss']
})
export class SurveyAddEditComponent implements OnInit {
  @Output() onDone: any = new EventEmitter();
  @Input() survey: any;
  form: any;
  constructor(private surveyService: SurveyService) { }

  ngOnInit(): void {
    this.form = {
      name: ""
    }
    if(this.survey != null) {
      this.form = this.survey
    }
  }

  onSaveHandler() {
    console.log(this.form)
    this.surveyService.add(this.form).subscribe({
      next: (res: any) => {
        this.onDone.emit(res.data)
      },
      error: (error: any) => {}
    })
  }
}
